import {observable, action, runInAction} from 'mobx'
import {get} from "../../../utils/ajax";
import {handleSearchAndPage, setStore, ValueObjToObj} from "../../../utils/Utils";
import {message} from 'antd'

class sparePartsChangeQueryStore {
    @observable loading
    @observable searchFields
    @observable list
    @observable pagination
    @observable formatMessage

    constructor(){
        this.loading = false
        this.searchFields={
            materialNo:'',
            spareNo:''
        }
        this.list=[]
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper:true,
            showSizeChanger:true,
            pageSize:10,
            showTotal:()=>`总共 0 条`
        }
        this.formatMessage = () =>{}
    }

    /**
     * 将值从页面绑到store
     * @param changedFields
     */
    @action
    onFieldsChange=(changedFields)=>{
        this.searchFields={...this.searchFields,...ValueObjToObj(changedFields)}
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 初始化页面
     * @returns {Promise<void>}
     */
    @action
    initPage=async (page)=>{
        if(!this.searchFields.materialNo&&!this.searchFields.spareNo){
            message.warning(this.formatMessage({id: 'ConfigureQuery.PleaseEnterTheSearchCriteria'}))
            return
        }
        this.loading = true
        let search = handleSearchAndPage(page, this.pagination, this.searchFields)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDeskChange/getFrntDeskSparePartChange:search`,search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(()=>{
            this.list=Array.isArray(res.content)?res.content:[]
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper:true,
                showSizeChanger:true,
                pageSize:res.size,
                showTotal:()=>`总共 ${res.totalElements} 条`
            }
            this.loading = false
        })
    }

    /**
     * 重置
     */
    @action
    clearSearch=()=>{
        this.searchFields={
            materialNo:'',
            spareNo:''
        }
        this.list=[]
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper:true,
            showSizeChanger:true,
            pageSize:10,
            showTotal:()=>{}
        }
    }

}
export default new sparePartsChangeQueryStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/SparePartsChangeQuery/store.js